module.exports = __webpack_public_path__ + "70fa69f1a79311ea931f5a139beb7ff0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/down-9.png
// module id = 3130
// module chunks = 0